/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_No_Groups_AvailableInputs */

const en_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No groups available. Create groups first to manage permissions.`)
};

const fr_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe disponible. Créez d’abord des groupes pour gérer les autorisations.`)
};

const de_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind keine Gruppen verfügbar. Erstellen Sie zuerst Gruppen, um Berechtigungen zu verwalten.`)
};

const it_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gruppo disponibile. Crea prima i gruppi per gestire le autorizzazioni.`)
};

const ru_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет доступных групп. Сначала создайте группы, чтобы управлять правами доступа.`)
};

const es_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay grupos disponibles. Cree grupos primero para administrar los permisos.`)
};

const zh_cn2_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无可用群组。请先创建群组以管理权限。`)
};

const ja_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なグループがありません。権限を管理するには、まずグループを作成してください。`)
};

const hi_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई समूह उपलब्ध नहीं है। अनुमतियों को प्रबंधित करने के लिए पहले समूह बनाएं।`)
};

const pt_pt2_knp_manager_no_groups_available = /** @type {(inputs: Knp_Manager_No_Groups_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há grupos disponíveis. Crie grupos primeiro para gerenciar permissões.`)
};

/**
* | output |
* | --- |
* | "No groups available. Create groups first to manage permissions." |
*
* @param {Knp_Manager_No_Groups_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_no_groups_available = /** @type {((inputs?: Knp_Manager_No_Groups_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_No_Groups_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_no_groups_available(inputs)
	if (locale === "de") return de_knp_manager_no_groups_available(inputs)
	if (locale === "it") return it_knp_manager_no_groups_available(inputs)
	if (locale === "ru") return ru_knp_manager_no_groups_available(inputs)
	if (locale === "es") return es_knp_manager_no_groups_available(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_no_groups_available(inputs)
	if (locale === "ja") return ja_knp_manager_no_groups_available(inputs)
	if (locale === "hi") return hi_knp_manager_no_groups_available(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_no_groups_available(inputs)
	return en_knp_manager_no_groups_available(inputs)
});